import styled, { useTheme } from 'foundations-theming/utils';
import { Flex } from '../../../../components/Flex/Flex';
import { filterProps } from '../../../../utils/filterProps';
import { useIsDisplayOptimized } from '../../../context/DisplayOptimizedContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFontSize = (theme, size) => {
  if (typeof size === 'number') return size;
  return size === 'small' ? parseInt(theme.typography['body-100'].fontSize, 10) : parseInt(theme.typography['body-200'].fontSize, 10);
};
const InputWrapper = styled.div.withConfig({
  displayName: "InputIconWrapper__InputWrapper",
  componentId: "sc-1hm5d4j-0"
})(({
  size,
  theme,
  $cssStyles,
  $isDisplayOptimized
}) => {
  return Object.assign({
    position: 'relative',
    '&& input': {
      paddingLeft: $isDisplayOptimized ? theme.space['500'] : `${20 + (size || 0)}px` // Provide a fallback if size is undefined
    }
  }, $cssStyles);
});
export const InputIconWrapper = props => {
  const {
    domProps
  } = filterProps(props);
  const isDisplayOptimized = useIsDisplayOptimized();
  const theme = useTheme();
  const {
    children,
    size,
    icon: Icon,
    disabled,
    $cssStyles,
    onFocus
  } = props;
  const computedSize = getFontSize(theme, size);
  return /*#__PURE__*/_jsxs(InputWrapper, Object.assign({}, domProps, {
    $cssStyles: $cssStyles,
    $isDisplayOptimized: isDisplayOptimized,
    size: computedSize,
    onFocus: onFocus,
    children: [children, /*#__PURE__*/_jsx(Flex, {
      position: "absolute",
      insetBlockEnd: "0",
      insetBlockStart: "0",
      insetInlineStart: "0",
      paddingInline: isDisplayOptimized ? '0' : '250',
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Icon, {
        color: disabled ? 'text-core-disabled' : 'inherit'
      })
    })]
  }));
};